import AuthorizationHelper from '@auth/services/authorization.helper';
import ModulesHelper from '@core/services/modules.helper';

const routes = [
  {
    path: 'certificates',
    name: 'admin-certificates',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.certificates],
      module: ModulesHelper.CERTIFICATES_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-certificates" */ '@certificates/pages/certificate/certificate.vue'
      ),
  },
  {
    path: 'certificate-categories',
    name: 'admin-certificate-categories',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.certificate_categories],
      module: ModulesHelper.CERTIFICATES_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-certificate-categories" */ '@certificates/pages/certificate-categories/certificate-categories.vue'
      ),
  },
];

export default routes;
